module.exports = __webpack_public_path__ + "static/media/icon-pencil.72c34369.svg";